// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------
// /assets/icons/navbar/${name}.svg
const icon = (name) => (
  <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const Reports = [
//   {
//     title: 'Operation Bulletin',
//     path: '/dashboard/manage/operation_bulletin',
//     icon: icon('obt'),
//     ShortName: 'Transaction_OperationBulletin',
//   },
//   {
//     title: 'Time & Study',
//     path: '/dashboard/manage/time_and_study',
//     icon: icon('ts'),
//     ShortName: 'Transaction_Time_and_Study',
//   },
//   {
//     title: 'Daily Production',
//     path: '/dashboard/manage/daily_production',
//     icon: icon('daily'),
//     ShortName: 'Transaction_DailyProduction',
//   },
  {
    title: 'Hourly Production',
    path: '/dashboard/reports/daily_production_hourly',
    icon: icon('hourly'),
    ShortName: 'Reports_HourlyProduction',
  },
  {
    title: 'OB Status',
    path: '/dashboard/reports/OBStatus',
    icon: icon('obstatus1'),
    ShortName: 'Reports_ObStatus',
  },
  {
    title: 'Production Tracker',
    path: '/dashboard/reports/ReportTracker',
    icon: icon('reportTracker'),
    ShortName: 'Reports_ReportTracker',
  },
  {
    title: 'Day Wise Prod Cost',
    path: '/dashboard/reports/DayWiseProductionCostReport',
    icon: icon('dayWiseTrackerReport'),
    ShortName: 'Reports_DayWiseProductionCostReport',
  },
  {
    title: 'Monthly Production',
    path: '/dashboard/reports/monthly_wise_production',
    icon: icon('month'),
    ShortName: 'Reports_MonthlyProduction',
  },
  {
    title: 'Skill Matrix(Daily)',
    path: '/dashboard/reports/daily_skillmatrix',
    icon: icon('idea'),
    ShortName: 'Reports_SkillMatrixDaily',
  },
    {
    title: 'Employee Cost Analysis',
    path: '/dashboard/reports/employee_wise_production',
    icon: icon('employeeCostAnalysis'),
    ShortName: 'Reports_EmployeeWiseEarning',
  },
  {
    title: 'Process Tracker',
    path: '/dashboard/reports/process_tracker',
    icon: icon('processTracker'),
    ShortName: 'Reports_ProcessTracker',
  },
    {
    title: 'Production Cost Insights',
    path: '/dashboard/reports/factoryexpensereport',
    icon: icon('processTracker'),
    ShortName: 'Reports_factoryexpensereport',
  },
    {
    title: 'Employee Master Report',
    path: '/dashboard/reports/ProcessEmpMap',
    icon: icon('employees'),
    ShortName: 'Reports_ProcessEmpMap',
  },
     {
    title: 'Manpower Report',
    path: '/dashboard/reports/ManpowerReport',
    icon: icon('processTracker'),
    ShortName: 'Reports_ManpowerReport',
  },

];

export default Reports;
